import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import StudioLocator from "./components/StudioLocator";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/studio-locator" element={<StudioLocator />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
